import { Controller } from 'stimulus';

class BusinessToggle extends Controller {
  connect() {
    this.onOrderTypeChange();
  }

  onOrderTypeChange() {
    this.checkCompanyNameVisibility();
    this.checkVatNumberVisibility();
    this.checkCocNumberVisibility();
  }

  checkCompanyNameVisibility() {
    const selectedOrderType = this.element.querySelector('[name=order_type]:checked');
    const isCompanyNameTargetVisible = selectedOrderType.value === 'business';
    const companyNameInput = this.companyNameTarget.querySelector('input');

    companyNameInput.required = isCompanyNameTargetVisible;

    this.companyNameTarget.style.display = isCompanyNameTargetVisible ? 'block' : 'none';
  }

  checkVatNumberVisibility() {
    const selectedOrderType = this.element.querySelector('[name=order_type]:checked');
    const isVatNumberTargetVisible = selectedOrderType.value === 'business';

    this.vatNumberTarget.style.display = isVatNumberTargetVisible ? 'block' : 'none';
  }

  checkCocNumberVisibility() {
    const selectedOrderType = this.element.querySelector('[name=order_type]:checked');
    const isCocNumberTargetVisible = selectedOrderType.value === 'business';

    this.cocNumberTarget.style.display = isCocNumberTargetVisible ? 'block' : 'none';
  }
}

BusinessToggle.targets = [
  'companyName',
  'vatNumber',
  'cocNumber',
];

export default BusinessToggle;
